<script setup lang="ts">
/**
 * UToastHost · 全局 toast 挂载点
 * ------------------------------------------------------------
 * UToast.useToast() 只存状态（items 单例），本组件负责渲染。
 * 在 AppShell 挂载一次，全站 toast.show() 即可见；
 * 点击任一条目可立即关闭。
 */
import { useToast } from './UToast'

const { items, dismiss } = useToast()
</script>

<template>
  <Teleport to="body">
    <div class="utoast-host" aria-live="polite">
      <TransitionGroup name="utoast">
        <div v-for="t in items" :key="t.id" class="utoast" title="点击关闭" @click="dismiss(t.id)">
          {{ t.msg }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
/* 挂载点：屏幕右下角（避让底部栏 58px；不占中间舞台，长文案横向铺开不挤成长条） */
.utoast-host {
  position: fixed; z-index: 500;
  right: 24px; bottom: 84px;
  display: flex; flex-direction: column; align-items: flex-end; gap: 8px;
  pointer-events: none;
}
.utoast {
  pointer-events: auto; cursor: pointer;
  max-width: min(460px, calc(100vw - 48px));
  padding: 10px 16px; border-radius: 10px;
  background: #232A35; color: #fff;
  font-size: 13px; line-height: 1.55; text-align: left;
  overflow-wrap: break-word;
  box-shadow: 0 6px 24px #0b122033, 0 2px 8px #0b122022;
}
.utoast-enter-active, .utoast-leave-active { transition: opacity .2s, transform .2s; }
.utoast-enter-from, .utoast-leave-to { opacity: 0; transform: translateY(8px); }
</style>
